export default {
  abbreviation: "En",
  inputPlaceholder: "Please enter",
  defaultRulesLabel: "This field",
  YxAction: {
    plm: "More",
    pbm: "Batch operation",
    tm: "Are you sure?",
    bm: "Back",
    jm: "Jump",
    rm: "Reset",
    sm: "Submit",
    am: "Action",
    pm: "Popup",
    asm: "Operation is successful",
    ssm: "Submitted successfully",
    usm: "Uploaded successfully",
    dsm: "Download successful",
  },
  YxButton: {
    t: "Button",
  },
  YxDropdown: {
    t: "Undefine",
  },
  YxListPage: {
    tm: "Result List",
  },
  YxMasterSlave: {
    am: "Please select an option",
    em: "Please select an option",
  },
  YxPopconfirm: {
    ot: "Yes",
    ct: "No",
  },
  YxSearchPanel: {
    uf: "Unfold",
    f: "fold",
    qt: "Search",
    ht: "Search options",
  },
  YxSku: {
    cm: "Please select the specification properties first",
    dt: "Whether to delete this specification？",
    dot: "Yes",
    dct: "No",
    dbt: "Delete",
    at: "Add",
    cip: "Please choose",
    pt: "Configuration specifications",
    addot: "Create specification",
    ost: "Set specifications",
    oit: "Specification information",
    ot: "Confirm",
    ct: "Cancel",
    ggl: "Specification items",
    ggz: "Specification values",
    ggzem: "Specification values cannot be repeated",
    addggz: "Add specification value",
    agg: "Add the specification",
    sl: "Single specification",
    ml: "Multi specification",
    ggtyle: "Specifications types",
    st: "Save",
    xn: "Project name",
    xval: "Project value",
    mtx: "Move up",
    mbx: "Move Down",
    dat: "Delete",
    bc: "Batch modifying",
  },
  YxTable: {
    ect: "Confirm",
    ecelt: "Cancel",
    formEdit: "Edit",
    detail: "Detail",
    formAdd: "New",
    nct: "Please select a data",
    sn: "Serial number",
    ft: "Filtrate",
    act: "Action",
    sumt: "Total {total} items",
    allCheck: "all",
  },
  YxStatus: {
    it: "Enabled",
    wt: "Discontinued",
    st: "Completed",
    et: "Error message",
  },
  YxTree: {
    st: "Please enter search criteria",
    nc: "No node selected!",
    dfkey: '"defaultSelectedKeys" Must be in array format',
  },
  Editor: {
    rusm: "Please upload the picture file",
    upMedia: "Please upload the video files",
    usm: "Uploaded successfully",
    uem: "Upload failed",
  },
  YxUpload: {
    cubt: "Click upload",
    cutt: "Click upload",
    cumt: "Click upload",
    cutht: "Click upload",
    dt: "Are you sure to delete this element?",
    dnt: "Uploaded successfully",
    ert: "Upload failed",
    rt: "File deleted successfully",
    lt: "Quantity is too large!",
    st: "The file is too big!",
  },
  YxModal: {
    ot: "Confirm",
    ct: "Cancel",
  },
  Certificates: {
    cm: "Please enter the correct id number",
    pm: "Please enter the correct passport number",
    jm: "Please enter the correct military id number",
  },
  defaultRules: {
    rt: "{label} is required",
    maxt: "The length of the {label} cannot be greater than {len} characters",
    lent: "The length of {label} requires {len} characters",
    mint: "The length of {label} cannot be less than {len} characters",
    wnlcm: "Please use Chinese, letters, underscores and Numbers",
    nc: "No Chinese support",
    wnlt: "Please use letters, underscores, and Numbers",
    wnlclt: "Please use letters, underscores, lines, and Numbers",
    hnlt: "Only beginning with letters. Use letters, underscores, Numbers, and dots",
  },
  Range: {
    pc: "Please complete {name}",
  },
  Email: {
    ecm: "Please enter the correct mailbox format",
  },
  PassWord: {
    em: "The passwords entered are inconsistent",
    rm: "Please enter a {l1}-{l2} digit password",
    lv1: "Password is an arbitrary combination of Numbers, letters, or special symbols",
    lv2: "Passwords are two or more combinations of Numbers, letters and special symbols",
    lv3: "The password is a combination of Numbers, letters and special symbols",
  },
  Phone: {
    pem: "The phone number is incorrect",
    tem: "The landline number is incorrect",
  },
  Url: {
    em: "Please enter the correct url format",
  },
  YxCascader: {
    ipt: "Please choose",
  },
};



// WEBPACK FOOTER //
// ./src/yx-widget/config/language/en_US.js